import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider,
  Paper,
  Grid
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getIcon } from '../../../utils/IconHandler';
import { getEmailTemplateCategoryLabel } from '../../../utils/Enums';

const ViewTemplateModal = ({ open, onClose, template }) => {
  const { t } = useTranslation();

  if (!template) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {getIcon('eye')}
        {t('view_template')} - {template.name}
      </DialogTitle>
      
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">
                {t('name')}:
              </Typography>
              <Typography variant="body1">{template.name}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">
                {t('category')}:
              </Typography>
              <Typography variant="body1">{getEmailTemplateCategoryLabel(template.category) || t('not_specified')}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" color="text.secondary">
                {t('subject')}:
              </Typography>
              <Typography variant="body1">{template.subject}</Typography>
            </Grid>
          </Grid>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h6" gutterBottom>
            {t('email_preview')}
          </Typography>
          <Paper sx={{ p: 2, minHeight: 400, border: '1px solid', borderColor: 'divider', mt: 2 }}>
            <Typography variant="h6" gutterBottom>
              {template.subject || t('email_preview')}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box
              dangerouslySetInnerHTML={{ __html: template.htmlContent || t('no_content') }}
              sx={{
                '& img': { maxWidth: '100%' },
                '& a': { color: 'primary.main' }
              }}
            />
          </Paper>
        </Box>
      </DialogContent>
      
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          {t('close')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewTemplateModal;

